import { PerformanceDatapoint } from 'owa-analytics';
import { TableQuery } from 'owa-mail-list-store';
import { ActionSource } from 'owa-mail-store';
import { action } from 'satcheljs';

export interface LoadTableViewFromSearchTableQueryActionMessage {
    searchTableQuery: TableQuery;
    searchEndToEndPerformanceDatapoint: PerformanceDatapoint;
    actionSource: ActionSource;
}

const loadTableViewFromSearchTableQuery = action(
    'LOAD_TABLE_VIEW_FROM_SEARCH_TABLE_QUERY_NEXT',
    (
        searchTableQuery: TableQuery,
        searchEndToEndPerformanceDatapoint: PerformanceDatapoint,
        actionSource: ActionSource
    ) => ({
        searchTableQuery: searchTableQuery,
        searchEndToEndPerformanceDatapoint: searchEndToEndPerformanceDatapoint,
        actionSource: actionSource,
    })
);

export default loadTableViewFromSearchTableQuery;
